module.exports = __webpack_public_path__ + "static/media/6.fb8c9260.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格未选中态/6.png
// module id = 1624
// module chunks = 0